<div style="width:100%;">
  <main>
    <article #fs [class.is-active]="isFullscreen" style="background-color: white; position: relative;">
      <div>
        <icon-chart [headerConfig]="headerConfig" [iconList]="iconList" [data]="chartData" [pageKey]="pageKey"
          [heading]="heading" [chartName]="divId" [config]="chartContainer" [expand]="fs" [fullscreen]="isFullscreen"
          [item]="item" [excelConfig]="this.item.config.excel_column?.columns" (screenChanges)="fullscreenChanges($event)">
        </icon-chart>
      </div>
      <div><loading *ngIf="isLoading"></loading></div>
      <div [style.display]="noData ? 'none' : ''" #chartContainer style="width:100%; min-height: 300px;">
      </div>
      <div style="height: 300px; width: auto;" *ngIf="noData">
        <span class="bg-text">{{ error_name ? error_name : 'There is no data for this time period' }}</span>
      </div>
    </article>
  </main>
</div>
